import { render, staticRenderFns } from "./OneClickLogin.vue?vue&type=template&id=d9ab44c8"
import script from "./OneClickLogin.vue?vue&type=script&lang=js"
export * from "./OneClickLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports